// Shared presentation helpers for the enforcement-actions register (Session AON): the labels for the
// two enums, and the date input helper (mirroring accidentsUi.tsx's own shape). The status PILL is the
// registry's (design system Session 7a): <StatusPill domain="enforcement" status={s} />.
import type { EnforcementActionStatus, EnforcementActionType } from "../../lib/api";

export const ACTION_TYPE_LABEL: Record<EnforcementActionType, string> = {
  improvement_notice: "Improvement notice",
  prohibition_notice: "Prohibition notice",
  prosecution: "Prosecution",
  other: "Other",
};

export const STATUS_LABEL: Record<EnforcementActionStatus, string> = {
  open: "Open",
  remedied: "Remedied",
  closed: "Closed",
};

export const ACTION_TYPES: EnforcementActionType[] = ["improvement_notice", "prohibition_notice", "prosecution", "other"];

// The same ISO instant as the value a <input type="date"> wants. Returns "" for null, so the field
// renders empty rather than showing "Invalid Date".
export function toDateInputValue(iso: string | null): string {
  return iso ? iso.slice(0, 10) : "";
}
